// extracted by mini-css-extract-plugin
export default {"invalid-error":"LohFranchiseForm_invalid-error__KPSOi","submitBtn":"LohFranchiseForm_submitBtn__P-7PL"};